import React, { useState, useEffect } from "react";
import cx from "classnames";
import styles from "../scss/AppFormField.module.scss";
import { IAnswerProps, IAppFormQuestion } from "../interfaces/IAppFormData";
import Tooltip from "../../common/components/Tooltips/Tooltip";
import { showHelpText } from "../shared/AppFormHelper";

interface IAFCheckboxListFieldProps {
    list: IAppFormQuestion[];
    formAnswerList: IAnswerProps[];
    answerChanges: (answerParam: IAnswerProps[]) => void;
    label?: string;
    helpText?: string;
}

interface IList {
    id: number;
    questionNumber: string;
    optionText: string;
}

const AFCheckboxListField: React.FC<IAFCheckboxListFieldProps> = (props) => {
    const { list, answerChanges } = props;

    const [checkList, setCheckList] = useState<IList[]>([]);

    const handleCheckList = (option): void => {
        const { id, questionNumber, questionText, clearsChecklist } = option;
        let newCheckList = checkList || [];
        const selectedObj = {
            id,
            questionNumber,
            optionText: questionText
        };
        if (!!clearsChecklist) {
            newCheckList = [selectedObj];
        } else {
            if (!!checkList.find((i) => i.optionText === questionText)) {
                const newList = checkList.filter((i) => i.optionText !== questionText);
                newCheckList = newList;
            } else {
                const deselectOption = list.find((i) => i.clearsChecklist);
                const newList = checkList.filter(
                    (i) => i.optionText !== deselectOption?.questionText || ""
                );
                newCheckList = [...newList, selectedObj];
            }
        }
        setCheckList(newCheckList);
        handleReturnValue(newCheckList);
    };

    const handleReturnValue = (checkList): void => {
        const returnListValue = list.reduce((acc, item) => {
            const itemSelected = checkList.find(
                (i) => i.optionText === item.questionText
            );
            return [
                ...acc,
                {
                    questionId: item.id,
                    disclosure: [],
                    answer: !!itemSelected?.id ? "Yes" : "No",
                    questionNumber: itemSelected?.questionNumber || item.questionNumber
                }
            ];
        }, []);
        answerChanges(returnListValue);
    };

    const handleActiveItem = (option): boolean => {
        const item = checkList.find(
            (i) => i.id === option.id && i.optionText === option.questionText
        );
        return !!item?.id || false;
    };

    const handleInitCheckList = (): void => {
        const newCheckList = list?.reduce((acc, item) => {
            if (item?.answer === "Yes") {
                return [
                    ...acc,
                    {
                        id: item.id,
                        optionText: item.questionLabel,
                        questionNumber: item.questionNumber
                    }
                ];
            }
            return acc;
        }, []);
        setCheckList(newCheckList);
        handleReturnValue(newCheckList);
    };

    useEffect(() => {
        if (list?.length) {
            handleInitCheckList();
        }
    }, []);

    return (
        <div className={styles["af-checkboxlist"]}>
            <fieldset className={cx([styles["af-radio-button"]])}>
                <legend>{props?.label}</legend>
                {props?.helpText &&
                    <div>
                    <p className="text-help">{props?.helpText}</p>
                    </div>
                }
                <p className="text-help">Select as many as you need.</p>
                {list.map((opt, idx) => (
                    <React.Fragment>
                        <div className={styles["flex-row"]} key={idx}>
                            <div className={styles["radiolist-button-l"]}>
                        <input
                            type="checkbox"
                            id={`radiocontrol-${idx}`}
                            name="radioControl"
                            value={opt.id}
                            checked={handleActiveItem(opt)}
                            onChange={() => {
                                handleCheckList(opt);
                            }}
                        />
                        <label
                            className={styles["radion-button--label-container"]}
                            htmlFor={`radiocontrol-${idx}`}>
                            <div
                                className={styles["rb--label"]}
                                dangerouslySetInnerHTML={{
                                    __html: opt.questionText || ""
                                }}></div>
                        </label>
                        </div>
                        {!!showHelpText(opt) && (
                            <Tooltip
                                className={styles["form-title-tooltip"]}
                                tooltipContent={<div dangerouslySetInnerHTML={{ __html: showHelpText(opt) }} />}
                                    />
                            )}
                        </div>
                    </React.Fragment>
                ))}
            </fieldset>
        </div>
    );
};

export default AFCheckboxListField;
